"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WARN_FEATUREFLAGS_AND_FLAGSETS = exports.ERROR_GETT_NO_PARAM_OBJECT = exports.ERROR_SELECTOR_NO_SPLITSTATE = exports.ERROR_MANAGER_NO_INITSPLITSDK = exports.ERROR_TRACK_NO_INITSPLITSDK = exports.ERROR_DESTROY_NO_INITSPLITSDK = exports.ERROR_GETT_NO_INITSPLITSDK = exports.ADD_TREATMENTS = exports.SPLIT_DESTROY = exports.SPLIT_TIMEDOUT = exports.SPLIT_UPDATE_WITH_EVALUATIONS = exports.SPLIT_UPDATE = exports.SPLIT_READY_FROM_CACHE_WITH_EVALUATIONS = exports.SPLIT_READY_FROM_CACHE = exports.SPLIT_READY_WITH_EVALUATIONS = exports.SPLIT_READY = exports.getControlTreatmentsWithConfig = exports.CONTROL_WITH_CONFIG = exports.CONTROL = exports.OFF = exports.ON = exports.VERSION = exports.DEFAULT_SPLIT_STATE_SLICE = void 0;
// Default value for the key where the Split piece of state is expected to be mounted.
exports.DEFAULT_SPLIT_STATE_SLICE = 'splitio';
exports.VERSION = 'redux-' + '1.11.0';
// Treatments
exports.ON = 'on';
exports.OFF = 'off';
exports.CONTROL = 'control'; // SplitIO's default value
exports.CONTROL_WITH_CONFIG = {
    treatment: 'control',
    config: null,
};
var getControlTreatmentsWithConfig = function (featureFlagNames) {
    return featureFlagNames.reduce(function (pValue, cValue) {
        pValue[cValue] = exports.CONTROL_WITH_CONFIG;
        return pValue;
    }, {});
};
exports.getControlTreatmentsWithConfig = getControlTreatmentsWithConfig;
// Action types
exports.SPLIT_READY = 'SPLIT_READY';
exports.SPLIT_READY_WITH_EVALUATIONS = 'SPLIT_READY_WITH_EVALUATIONS';
exports.SPLIT_READY_FROM_CACHE = 'SPLIT_READY_FROM_CACHE';
exports.SPLIT_READY_FROM_CACHE_WITH_EVALUATIONS = 'SPLIT_READY_FROM_CACHE_WITH_EVALUATIONS';
exports.SPLIT_UPDATE = 'SPLIT_UPDATE';
exports.SPLIT_UPDATE_WITH_EVALUATIONS = 'SPLIT_UPDATE_WITH_EVALUATIONS';
exports.SPLIT_TIMEDOUT = 'SPLIT_TIMEDOUT';
exports.SPLIT_DESTROY = 'SPLIT_DESTROY';
exports.ADD_TREATMENTS = 'ADD_TREATMENTS';
// Warning and error messages
exports.ERROR_GETT_NO_INITSPLITSDK = '[ERROR] To use "getTreatments" the SDK must be first initialized with an "initSplitSdk" action';
exports.ERROR_DESTROY_NO_INITSPLITSDK = '[ERROR] To use "destroySplitSdk" the SDK must be first initialized with an "initSplitSdk" action';
exports.ERROR_TRACK_NO_INITSPLITSDK = '[ERROR] To use "track" the SDK must be first initialized with an "initSplitSdk" action';
exports.ERROR_MANAGER_NO_INITSPLITSDK = '[ERROR] To use the manager, the SDK must be first initialized with an "initSplitSdk" action';
exports.ERROR_SELECTOR_NO_SPLITSTATE = '[ERROR] When using selectors, "splitState" value must be a proper splitio piece of state';
exports.ERROR_GETT_NO_PARAM_OBJECT = '[ERROR] "getTreatments" must be called with a param object containing a valid splitNames or flagSets properties';
exports.WARN_FEATUREFLAGS_AND_FLAGSETS = '[WARN]  Both splitNames and flagSets properties were provided. flagSets will be ignored';
